import React from 'react'
import Button from '@renderer/components/Button'
import { useTranslation } from 'react-i18next'

interface ConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message
}) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-5 sm:p-8">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl sm:p-8">
        <h2 className="mb-4 text-2xl font-bold">{title}</h2>
        <p className="mb-8 text-gray-600">{message}</p>
        <div className="flex justify-end gap-3">
          <Button
            text={t('common.cancel')}
            variant="secondary"
            onClick={onClose}
            className="!px-6 !py-2 !text-base"
          />
          <Button text={t('common.yes')} onClick={onConfirm} className="!px-6 !py-2 !text-base" />
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
